import React, { useContext } from "react";
import { CHAT_PROVIDER } from "../../Config/Environment";
import { FixtureDetailsContext } from "../../Config/FixtureDetails";
import FreshChat from "./FreshChat";
import ServiceNowChat from "./ServiceNowChat";

const chatComponents = {
  freshchat: FreshChat,
  servicenow: ServiceNowChat,
};

const ChatComponent = Object.prototype.hasOwnProperty.call(chatComponents, CHAT_PROVIDER)
  ? chatComponents[CHAT_PROVIDER]
  : null;

export const ChatProvider = ({ children, currentState }) => {
  const { sport } = useContext(FixtureDetailsContext);

  return (
    <>
      {children}
      {sport === "handball" && ChatComponent && <ChatComponent currentState={currentState} />}
    </>
  );
};
